import React, { Component } from 'react';
import styles from './styles';

import { AxlTextArea, AxlPanel, AxlButton } from 'axl-reactjs-ui';
import {inject, observer} from "mobx-react";

@inject('deliveryStore')
@observer
class ShipmentDropoffForm extends Component {
  state = {
    updating: false,
    oldNote: '',
  };

  componentDidMount() {
    const { shipmentDropoffForm } = this.props.deliveryStore;
    const oldNote = shipmentDropoffForm.getField('dropoff_note', '');

    this.setState({oldNote});
  }

  closeWithoutSave = () => {
    const { shipmentDropoffForm } = this.props.deliveryStore;
    shipmentDropoffForm.setField('dropoff_note', this.state.oldNote);

    this.props.closeForm();
  };

  save = (e) => {
    const {deliveryStore, shipment, closeForm} = this.props;
    this.setState({updating: true})
    deliveryStore.updateShipmentDropoff(shipment, (res) => {
      this.setState({updating: false})
      closeForm();
    });
  };

  render() {
    const { shipment, deliveryStore } = this.props;
    const { shipmentDropoffForm } = deliveryStore;

    return <div style={styles.Container}>
      <div style={styles.HeaderTitle}>{`Edit Dropoff Note`}</div>
      <AxlPanel>
        <AxlPanel.Row>
          <AxlPanel.Col style={styles.GroupPanel}>
            <AxlPanel.Row align={`center`}>
              <AxlPanel.Col>
                <div style={styles.GroupTitle}>{`Dropoff Notes`}</div>
                <div style={styles.Field}>
                  <AxlTextArea
                    defaultValue={shipmentDropoffForm.getField('dropoff_note', '')}
                    onChange={shipmentDropoffForm.handlerInput}
                    placeholder={`Dropoff Notes`}
                    name={`dropoff_note`}
                    type={`textarea`}
                    style={{minHeight: 120}}
                    fluid
                  />
                </div>
              </AxlPanel.Col>
            </AxlPanel.Row>
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row>
          <AxlPanel.Col>
            <AxlPanel.Row align={`flex-end`}>
              <div style={{...styles.Field, ...styles.FieldButton}}>
                <AxlButton compact bg={`gray`}
                           onClick={this.closeWithoutSave}
                           style={styles.buttonControl}
                >
                  {`Cancel`}
                </AxlButton>
              </div>
              <div style={{...styles.Field, ...styles.FieldButton}}>
                <AxlButton compact bg={`pink`}
                           onClick={this.save}
                           style={styles.buttonControl}
                           loading={this.state.updating}
                >
                  {`Save`}
                </AxlButton>
              </div>
            </AxlPanel.Row>
          </AxlPanel.Col>
        </AxlPanel.Row>
      </AxlPanel>
    </div>
  }
}

export default ShipmentDropoffForm;